<template>
  <div
    id="About"
    class="mx-auto max-w-3xl px-8 py-16 lg:flex lg:max-w-6xl lg:gap-10 lg:py-12"
  >
    <div class="w-full lg:w-1/2">
      <div class="relative max-w-lg lg:max-w-xl">
        <h2
          class="relative text-2xl font-semibold leading-tight tracking-tight text-[#20484F] md:text-4xl lg:text-[2.7em] lg:leading-tight"
        >
          Tracking scope 1, 2 and 3
          <span class="span-underline">emissions</span> using real activity
          data.
        </h2>
      </div>
      <div class="mb-8 max-w-lg md:mb-10 lg:mb-14 lg:max-w-lg">
        <p class="mt-6 text-base text-gray-500 md:text-base lg:text-base">
          Veridis integrates across your corporate enterprise systems to
          automate data collection and emissions calculations, allowing you to
          make data-driven decisions to reach your sustainability goals.
        </p>
      </div>
      <div class="flex gap-3 md:space-x-3">
        <NuxtLink
          to="/contact-us"
          class="block w-full select-none rounded-md border-2 border-green-800/50 bg-green-700 px-5 py-3 text-center text-sm font-normal text-white hover:bg-green-800 active:bg-green-700 md:w-40 lg:w-auto lg:px-10 lg:py-4 lg:text-sm"
        >
          <span>Talk to Us</span>
        </NuxtLink>
      </div>
    </div>

    <div class="mt-10 w-full lg:mt-0 lg:w-1/2">
      <div class="grid grid-cols-2 gap-4">
        <div class="lg:pb-16">
          <span
            class="counter mb-2 block text-2xl font-semibold leading-tight tracking-tight text-[#20484F] lg:text-[1.3em] lg:leading-tight"
          >All Scopes Covered</span>
          <span
            class="lg:text-md md:text-md block text-base font-normal leading-tight text-gray-500 lg:leading-tight"
          >As outlined in GHG Protocol</span>
        </div>
        <div class="lg:pb-16">
          <span
            class="mb-2 block text-2xl font-semibold leading-tight tracking-tight text-[#20484F] lg:text-[1.3em] lg:leading-tight"
          >50+ Pollutants Tracked</span>
          <span
            class="lg:text-md md:text-md block text-base font-normal leading-tight text-gray-500 lg:leading-tight"
          >With automatically updated GWP values as per latest IPCC
            report</span>
        </div>
        <div>
          <span
            class="mb-2 block text-2xl font-semibold leading-tight tracking-tight text-[#20484F] lg:text-[1.3em] lg:leading-tight"
          >50,000+ Supply Chain Activities Covered</span>
          <span
            class="lg:text-md md:text-md block text-base font-normal leading-tight text-gray-500 lg:leading-tight"
          >Across all GHG Protocol categories and types</span>
        </div>
        <div>
          <span
            class="mb-2 block text-2xl font-semibold leading-tight tracking-tight text-[#20484F] lg:text-[1.3em] lg:leading-tight"
          >5+ Reporting Frameworks</span>
          <span
            class="lg:text-md md:text-md block text-base font-normal leading-tight text-gray-500 lg:leading-tight"
          >Reports generated in alignment with most commonly used frameworks,
            including TCFD, CDP, GRI and more.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroductionSection',
}
</script>
